import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["lightIcon", "darkIcon"];

  connect() {
    // Always start in light mode unless user has explicitly saved a preference
    this.initializeTheme();
  }

  initializeTheme() {
    // If no preference is saved, default to light mode
    if (!("theme" in localStorage)) {
      localStorage.theme = "light";
    }

    // Apply saved preference
    this.updateThemeDisplay();
    this.updateIcons();
  }

  toggle() {
    // Simple two-way toggle: light <-> dark
    const currentTheme = this.getCurrentTheme();

    if (currentTheme === "light") {
      this.setTheme("dark");
    } else {
      this.setTheme("light");
    }
  }

  getCurrentTheme() {
    return localStorage.theme || "light";
  }

  setTheme(theme) {
    localStorage.theme = theme;
    this.updateThemeDisplay();
    this.updateIcons();
  }

  updateThemeDisplay() {
    // Apply dark class only if explicitly set to dark
    const shouldBeDark = localStorage.theme === "dark";
    document.documentElement.classList.toggle("dark", shouldBeDark);
  }

  updateIcons() {
    if (!this.hasLightIconTarget || !this.hasDarkIconTarget) return;

    const currentTheme = this.getCurrentTheme();

    // Hide all icons first
    this.lightIconTarget.classList.add("hidden");
    this.darkIconTarget.classList.add("hidden");

    // Show appropriate icon based on current theme
    if (currentTheme === "light") {
      this.lightIconTarget.classList.remove("hidden");
    } else {
      this.darkIconTarget.classList.remove("hidden");
    }
  }
}
